import React, { Component } from 'react';
import { Container, Row, Col } from 'reactstrap';
import Bharath_Icon from 'assets/images/bharat-qr.svg';
import { withTranslation } from 'react-i18next';

class PaymentHeader extends Component {

    state = {
        initialState: '',
        mode: 'Payment Mode',
        typeOfCard: 'Credit Card'
    }

    render() {
        const { t } = this.props;
        return(
            <section className="container-fluid card-title-panel">
                <Container>
                    <Row>
                        {
                            this.props.menuListCount > 1 &&
                            <Col xs="12" lg="4" className="d-none d-lg-block">
                                <div className="card-title ml-3">
                                    <h4>{t(this.state.mode)}</h4>
                                </div>
                            </Col>
                        }
                        <Col xs="12" lg={this.props.menuListCount>1 ? 8 : 12} >
                            <div className="card-title d-flex justify-content-center card-title-detail">
                                <h4 className={this.props.menuListCount > 1 ? '' : 'vertical-mid-title'}>
                                    {this.props.selectedPayment==='IDEBIT' ? t('idebitDisplayHeader') : t(this.props.selectedPayment)}
                                    {
                                        (this.props.selectedPayment === "BHARATQR" && <img src={Bharath_Icon} alt="card" title="" />)
                                    }
                                </h4>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
        );
    }
}

export default withTranslation('translations')(PaymentHeader);